export default __webpack_public_path__ + "static/media/services8.c43b7de2.jpg";